import { useContext } from "react";
import { MainContext } from "../App";
import HamburgerIcon from "../icons/HamburgerIcon";
import SearchIcon from "../icons/SearchIcon";
import { useAppStore } from "../useAppStore";
import CloseIcon from "../icons/CloseIcon";

function Header() {
	const { table, setMenuVisible } = useContext(MainContext);
	const { src, setSrc } = useAppStore();

	return (
		<header>
			<div>
				<div className="header-left-actions">
					<button
						onClick={() => setMenuVisible(true)}
						className="btn btn-tertiary btn-square"
					>
						<HamburgerIcon />
					</button>
				</div>
				<div>
					<div><strong>{table ? table.name : "nessuno"}</strong></div>
					<div className="extrasmall">{table?.list_id ? table?.list?.name || "Base" : "Base"}</div>
				</div>
			</div>
			<div className="header-right">
				<div className="header-src">
					<input
						type="text"
						placeholder="Cerca prodotto"
						value={src}
						onChange={(e) => setSrc(e.target.value)}
					/>

					{src ? (
						<button className="clear-btn" onClick={() => setSrc("")}><CloseIcon /></button>
					) : (
						<div className="search-icon"><SearchIcon /></div>
					)}
				</div>
			</div>
		</header>
	);
}

export default Header;
